module.exports = __webpack_public_path__ + "static/media/expired-link-icon.8a0fcae2.png";